import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const NewsCard = ({ article, size = "md" }) => {
  const aspect =
    size === "xl" ? "aspect-[16/9]" : size === "sm" ? "aspect-[4/3]" : "aspect-[16/10]";
  const titleCls =
    size === "xl"
      ? "text-4xl sm:text-5xl"
      : size === "lg"
      ? "text-3xl"
      : size === "sm"
      ? "text-xl"
      : "text-2xl";

  return (
    <Link
      to={`/news/${article.slug}`}
      data-testid={`news-card-${article.slug}`}
      className="card-hover group block border border-border bg-card"
    >
      <div className={`relative ${aspect} overflow-hidden bg-secondary`}>
        <img
          src={article.image}
          alt={article.title}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute left-3 top-3 bg-primary px-2 py-1 overline-eyebrow text-primary-foreground">
          {article.category}
        </div>
      </div>
      <div className="flex flex-col gap-3 p-4">
        <h3
          className={`font-display uppercase leading-none ${titleCls} text-foreground group-hover:text-primary`}
        >
          {article.title}
        </h3>
        {size !== "sm" && (
          <p className="line-clamp-2 text-sm text-muted-foreground">{article.excerpt}</p>
        )}
        <div className="flex items-center justify-between pt-1 text-xs text-muted-foreground">
          <span className="uppercase tracking-wider">
            {article.author} · {article.date}
          </span>
          <ArrowUpRight
            size={16}
            className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
          />
        </div>
      </div>
    </Link>
  );
};

export default NewsCard;
